import axios from './axios';

const api = {

	//获取新闻列表
	getNews(params) {
		return axios.get('/web/query', {
			params
		});
	},
	//获取新闻详情
	getNewsDetail(params) {
		return axios.get('/web/detail', {
			params
		});
	},


};

export default api;